import useSources from 'new/state/sources/repository/useSources';
import useSourcesAdapter from 'new/state/sources/adapter/useSourcesAdapter';
import useDataSet from 'new/state/data_set/repository/useDataSet';
import { useDataSetAdapter } from 'new/state/data_set/adapter/useDataSetAdapter';
import useSinks from 'new/state/sinks/repository/useSinks';
import useSinksAdapter from 'new/state/sinks/adapter/useSinksAdapter';
import { tryCatchAsync } from 'new/utils/TryCatch';
import { useHistory } from 'react-router-dom';

const getResourceTriageURL = (id: number) =>
  `/monitor/resource-triage?type=flows&id=${id}&tab=insights`;

export function useFlowInsightsNavigationButton(resourceId: number, resourceType: string) {
  const history = useHistory();
  const { getSourceById } = useSources();
  const { getSourceById: fetchSourceById } = useSourcesAdapter();
  const { getDataSetById } = useDataSet();
  const { requestDataSetById } = useDataSetAdapter();
  const { getSinkById } = useSinks();
  const { getSinkById: fetchSinkById } = useSinksAdapter();

  const getResourceByType = async () => {
    let retrievedResource: any;

    if (resourceType === 'SOURCE') {
      retrievedResource = getSourceById(resourceId);
      if (!retrievedResource) {
        retrievedResource = await fetchSourceById(resourceId);
      }
    }

    if (resourceType === 'DATA_SET') {
      retrievedResource = getDataSetById(resourceId);
      if (!retrievedResource) {
        retrievedResource = await requestDataSetById(resourceId);
      }
    }

    if (resourceType === 'DATA_SINK' || resourceType === 'SINK') {
      retrievedResource = getSinkById(resourceId);
      if (!retrievedResource) {
        retrievedResource = await fetchSinkById(resourceId);
      }
    }

    return retrievedResource;
  };

  const navigateToFlowInsights = async () => {
    const { error, data } = await tryCatchAsync(getResourceByType());

    if (error) {
      console.error(error);
      return;
    }

    if (!data?.flow_node_id) {
      console.error('Invalid Flow Node ID');
      return;
    }

    history.push(getResourceTriageURL(data.flow_node_id));
  };

  return { navigateToFlowInsights };
}
